import { useState, useEffect, Fragment, useContext, type PropsWithChildren } from 'react';
import { saveAs } from 'file-saver';
import { SessionContext } from '../../../utility/useSession';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface WaReportDefectHistoryDownloaderProps {
    callBack: () => void;
    defectId: number;
    show: boolean;
}

const WaReportDefectHistoryDownloader = ({ defectId, show, children, callBack }: PropsWithChildren<WaReportDefectHistoryDownloaderProps>) => {
    const [downloading, setDownloading] = useState<boolean>(false);

    const [progress, setProgress] = useState<number>(0);
    const [totalFiles, setTotalFiles] = useState<number>(0);
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    useEffect(() => {

        const downloadFiles = async () => {
            if (!show) return;
            if (downloading) return;

            setDownloading(true);
            setProgress(0);
            setTotalFiles(1);



            const url = `${session.current.context.url}/documents/generateBusWalkaroundDefectHistoryPDFStream`;


            try {
                const response = await fetch(url, {
                    method: 'POST',
                    body: JSON.stringify({ defectId: defectId }),
                    headers: {
                        'Content-Type': 'application/json',
                        "authorization": session.current.context.headers.authorization
                    }
                });

                if (!response.ok) {
                    throw new Error(t("walkarounds.failedToDownload", { file: defectId }));
                }
                const contentDisposition = response.headers.get('content-disposition');
                const contentDispositionFilename = (contentDisposition?.split('filename=')[1] ?? "").split(";")[0] ?? `DEFECT${defectId.toString().padStart(5, "0")}.pdf`;

                const blob = await response.blob();

                saveAs(blob, contentDispositionFilename);
                setDownloading(false);
                setProgress(0);
                callBack();

                // Update progress
                setProgress(1);
            } catch (error) {
                console.error(error);

            }
        };

        downloadFiles();
    }, [show, defectId, callBack, session]);

    return (
        <Fragment>
            {downloading && (
                <Dialog open={show}>
                    <DialogTitle>{t("walkarounds.reportDownloading")}</DialogTitle>
                    <DialogContent>
                        <div style={{ textAlign: "center" }}>
                            <p>{t("walkarounds.fileProgress", { count: progress, total: totalFiles })}</p>
                            <p>{t("walkarounds.fileComplete", { amount: Math.floor((progress / totalFiles) * 100) })}</p>
                            <div>
                                <progress value={(progress / totalFiles)} max={1} />
                            </div>
                        </div>
                    </DialogContent>

                </Dialog>
            )}


            {(!downloading) && children}
        </Fragment>
    );
};

export default WaReportDefectHistoryDownloader;
